var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "mt10", attrs: { name: "query-sort-block" } },
      [
        _c("swb-query-sort-area", {
          ref: "query_model_ctrl",
          attrs: {
            confKey: _vm.confKey,
            configAuto: true,
            queryOnLoad: _vm.queryOnLoad,
            queryHandler: _vm.queryHandler
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _vm.userInfo != null && _vm.userInfo.comLevel == 1
      ? _c("div", { staticClass: "simple-row clearfix" }, [
          _c("div", { staticClass: "left" }, [
            _c(
              "div",
              {
                staticClass: "swb-btn swb-btn-small",
                on: {
                  click: function($event) {
                    _vm.complaintSend()
                  }
                }
              },
              [_vm._v("发起投诉")]
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "tab-container small base", attrs: { name: "tab-btn" } },
      [
        _c("div", { staticClass: "tabs-nav" }, [
          _c(
            "ul",
            { staticClass: "head" },
            _vm._l(_vm.complaintStateList, function(text, value) {
              return _c(
                "li",
                {
                  staticClass: "head-item",
                  class: { current: value == _vm.checkStateValue },
                  on: {
                    click: function($event) {
                      _vm.tabChange(value)
                    }
                  }
                },
                [_c("span", [_vm._v(_vm._s(text))])]
              )
            })
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-layout" },
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: {
              height: _vm.theTableHeight,
              data: _vm.complaintList,
              border: ""
            }
          },
          [
            _c("el-table-column", {
              attrs: {
                prop: "dstMerchantName",
                label: "被投诉方",
                width: "180"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "content", label: "问题描述" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "createTime", label: "投诉时间", width: "260" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "状态", width: "180", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.mode == 0 && !rows.row.closed
                        ? _c("span", [_vm._v("协商中")])
                        : _vm._e(),
                      _vm._v(" "),
                      rows.row.mode == 1 && !rows.row.closed
                        ? _c("span", [_vm._v("协调中")])
                        : _vm._e(),
                      _vm._v(" "),
                      rows.row.closed
                        ? _c("span", [_vm._v("已关闭")])
                        : _vm._e()
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "操作", width: "260" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      _c(
                        "a",
                        {
                          staticClass: "swb-btn-link",
                          on: {
                            click: function($event) {
                              _vm.toComplaintInfo(rows.row.id)
                            }
                          }
                        },
                        [_vm._v("查看详情")]
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pagination-layout" },
      [
        _c("el-pagination", {
          attrs: {
            background: "",
            "page-size": _vm.pageSize,
            "page-sizes": _vm.pageSizes,
            "current-page": _vm.pageNumber,
            total: _vm.totalCount,
            layout: "prev, pager, next, jumper, sizes, total"
          },
          on: {
            "current-change": _vm.handlePageChange,
            "size-change": _vm.handleSizeChange
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3eccd650", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eccd650","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/custsvc/ComplaintSendList.vue
// module id = 2711
// module chunks = 0